// In back-end - src\microservices\migration.microservice\src\migration\rates.migration.ts
const CURRENCIES = {
	UAH: {
		code: "UAH",
		symbol: "₴",
		name: "грн",
		excelCode: "[$₴-uk-UA]",
	},
	PLN: {
		code: "PLN",
		symbol: "zł",
		name: "zł",
		excelCode: "[$zł-pl-PL]",
	},
	AZN: {
		code: "AZN",
		symbol: "₼",
		name: "₼",
		excelCode: "[$₼-az-AZ]",
	},
	MDL: {
		code: "MDL",
		symbol: "L",
		name: "lei",
		excelCode: "[$L-ro-MD]",
	},
	GEL: {
		code: "GEL",
		symbol: "₾",
		name: "lari",
		excelCode: "[$₾-ka-GE]",
	},
} as const;

const CURRENCY_SUFFIXES: СurrencyDefinitions.Suffixes[] = Object.values(
	CURRENCIES,
).flatMap(({ symbol, name, code }) => [symbol, name, code].filter(Boolean));

function getCurrencySymbol(
	input: СurrencyDefinitions.Suffixes,
): СurrencyDefinitions.CurrencySymbol | undefined {
	return Object.values(CURRENCIES).find(
		({ code, symbol, name }) =>
			input.toLowerCase() === code.toLowerCase() ||
			input.toLowerCase() === name.toLowerCase() ||
			input === symbol,
	)?.symbol;
}

declare namespace СurrencyDefinitions {
	type Code = (typeof CURRENCIES)[keyof typeof CURRENCIES]["code"];
	type CurrencySymbol =
		(typeof CURRENCIES)[keyof typeof CURRENCIES]["symbol"];
	type Name = (typeof CURRENCIES)[keyof typeof CURRENCIES]["name"];
	type ExcelCode = (typeof CURRENCIES)[keyof typeof CURRENCIES]["excelCode"];

	type Suffixes = Code | CurrencySymbol | Name;

	type Key = keyof typeof CURRENCIES;

	type Value = {
		[K in Key]: {
			code: (typeof CURRENCIES)[K]["code"];
			symbol: (typeof CURRENCIES)[K]["symbol"];
			name: (typeof CURRENCIES)[K]["name"];
			excelCode?: (typeof CURRENCIES)[K]["excelCode"];
		};
	}[Key];
}

export { CURRENCIES, CURRENCY_SUFFIXES, getCurrencySymbol };
export default СurrencyDefinitions;
